import React from "react";

const TemplateSelector = ({ templates, selectedTemplates, setSelectedTemplates }) => {
  const toggleTemplate = (id) => {
    setSelectedTemplates((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id]
    );
  };

  console.log(templates)

  return (
    <div>
      <h2>Select Report Templates:</h2>
      {templates.map((template) => (
        <label key={template.id} style={{ display: "block", margin: "5px 0" }}>
          <input
            type="checkbox"
            checked={selectedTemplates.includes(template.id)}
            onChange={() => toggleTemplate(template.id)}
          />
          {template.name}
        </label>
      ))}
    </div>
  );
};

export default TemplateSelector;